import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LazyLoadEvent } from 'primeng/api';
import { BaseViewComponent } from '../../../../../../shared/core/interfaces/baseViewComponent';
import { LookupService } from '../../../../../../shared/core/services/lookup.service';
import { ToastService } from '../../../../../../shared/core/services/toast.service';
import { EventLocationModel } from '../../../../api/models/event-location-model';
import { EventLocationService } from '../../../../api/services/event-location.service';
import { FilterLocationComponent } from './filter-location/filter-location.component';
import { FindFilter } from '../../../../api/models/find-filter';


@Component({
  selector: 'pars-select-location',
  templateUrl: './select-location.component.html',
  styleUrls: ['./select-location.component.css']
})
export class SelectLocationComponent extends BaseViewComponent {
  @ViewChild(FilterLocationComponent) filterLocation: FilterLocationComponent;

  @Input() selectedItem: EventLocationModel;
  @Input() set eventId(value) {
    this.currentEventId = value;
    this.initializeFilter();
    this.getData(false);
  };

  @Output() cancel = new EventEmitter<boolean>();
  @Output() selection = new EventEmitter<number>();

  private _locationList$: BehaviorSubject<EventLocationModel[]> = new BehaviorSubject<EventLocationModel[]>([]);
  get locationList$() {
    return this._locationList$.asObservable();
  }
  get locationList() {
    return this._locationList$.value;
  }
  
  currentEventId: number;
  first: number = 0;
  count: number = 0;
  modelError="";

  filter: FindFilter = {};
  searchKeyValues = {
    "Name": "",
    "City": "",
    "StateNameId": ""
  };

  columns: any[] = [
    { header: "Location", field: "locationName" },
    { header: "Street Address", field: "address" },
    { header: "City", field: "city" },
    { header: "State", field: "state" },
    { header: "Active", field: "active" }
  ];

  latestSearchCode = 0;

  constructor(
    private _eventLocationService: EventLocationService,
    private _toastService: ToastService,
    public lookupService: LookupService) {
    super(lookupService);

    this.loadLookups();
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  onClear() {
    this.first = 0;
    this.initializeFilter();
    this.getData(false);
  }

  onReloadList(event: LazyLoadEvent) {
    let displayData: boolean = this.filter.findKeys !== undefined;
    let sortField = "";
    switch (event.sortField) {
      case "locationName":
        sortField = "Name";
        break;
      case "address":
        sortField = "Address";
        break;
      case "city":
        sortField = "City";
        break;
      case "state":
        sortField = "StateName.Name";
        break;
    }

    this.first = event.first;
    let pageNumber = this.first / event.rows;
    
    this.filter = Object.assign(this.filter, {
      pagingInfo: {
        "pageNumber": pageNumber,
        "pageSize": event.rows
      },
      sortInfos: [
        {
          "columnName": sortField,
          "isDescending": event.sortOrder === -1 ? true : false
        }
      ] 
    });
    if (displayData) {
      this.getData(false);
    }
  }
  
  onSearch(event) {
    if (event["Name"] != this.filter.findKeys["Name"] ||
        event["City"] != this.filter.findKeys["City"] ||
        event["StateNameId"] != this.filter.findKeys["StateNameId"]) {
      this.first = 0;
      this.filter.pagingInfo.pageNumber = 0;
    }
    this.searchKeyValues = Object.assign(this.searchKeyValues, event);
    this.filter.findKeys = Object.assign(this.filter.findKeys, this.searchKeyValues);
    this.getData(true);
  }
  
  onSelectClick(event: EventLocationModel) {
    this.selection.emit(event.id);
  }

  private getData(searching: boolean) {
    //save a unique key for the most recent search
    let searchCode = ++this.latestSearchCode;

    this.safeSubscribe(this._eventLocationService.FindInDomain(this.filter), data => {
      if (searchCode == this.latestSearchCode) {
        this._locationList$.next(data);
        this.count = data["TotalRecordCount"];
        if (searching) {
          this.filterLocation.onSearchComplete();
        };
        this.modelError = "";
      }
    }, error => this._toastService.showError(error));
  }

  private initializeFilter() {
    this.filter = {
      findKeys: {
        "Active": "true",
        "EventId": this.currentEventId.toString()
      },
      includes: ["StateName"],
      pagingInfo: {
        "pageNumber": this.first / 10,
        "pageSize": 10
      },
      sortInfos: [
        {
          columnName: "Name",
          isDescending: false
        }
      ]
    };
  }

  private loadLookups() {
    this.safeSubscribe(this._eventLocationService.Lookups(), data => {
      this.lookupService.loadLookups(data);
      }, error => this._toastService.showError(error));
  }

}
